// date-fns format strings
export const SEND_DATES_FORMAT = 'yyyy-MM-dd';
export const DISPLAY_DATES_FORMAT = 'dd.MM.yyyy';
export const DISPLAY_DATETIME_FORMAT = 'dd.MM.yyyy HH:mm';
export const DISPLAY_DATES_FORMAT_ENG = 'MM/dd/yyyy';
export const MONTH_FORMAT = 'yyyy-MM';
export const DISPLAY_MONTH_FORMAT = 'MM.yyyy';
export const DAYS_COUNT_IN_WEEK = 7;
// Moment.js indexes weekdays array starting from Sunday (0)
// So arrays are ordered: [Sunday, Monday, Tuesday, Wednesday, Thursday, Friday, Saturday]
export const UK_WEEKDAYS_MIN = ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
export const UK_WEEKDAYS_SHORT = [
  'Ндл',
  'Пнд',
  'Втр',
  'Срд',
  'Чтв',
  'Птн',
  'Сбт',
];
export const UK_WEEKDAYS = [
  'Неділя',
  'Понеділок',
  'Вівторок',
  'Середа',
  'Четвер',
  "П'ятниця",
  'Субота',
];
export const UA_MONTHS = [
  'Січень',
  'Лютий',
  'Березень',
  'Квітень',
  'Травень',
  'Червень',
  'Липень',
  'Серпень',
  'Вересень',
  'Жовтень',
  'Листопад',
  'Грудень',
];
export const UA_MONTHS_SHORT = [
  'Січ',
  'Лют',
  'Бер',
  'Кві',
  'Тра',
  'Чер',
  'Лип',
  'Сер',
  'Вер',
  'Жов',
  'Лис',
  'Гру',
];
